import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Editor } from 'primereact/editor';
import { trainingApi } from '../../services';
import { toast } from "react-toastify";

export default function TrainingEffectivenessReport({ clickedRowData, reloadTrfHistory }) {
  console.log(clickedRowData, "clickedRowDataclickedRowData")
  const [empTrfDetailId, setEmpTrfDetailId] = useState('');
  const [finalReport, setFinalReport] = useState(null);
  const [nominatedParticipant, setNominatedParticipant] = useState();
  const [trainingType, setTrainingType] = useState(null);
  const [targetSkill, setTargetSkill] = useState(null);
  const [outcomeAchievedStatus, setOutcomeAchievedStatus] = useState();
  const [managerFeedbackComment, setManagerFeedbackComment] = useState();
  const [effectivenessSummary, setEffectivenessSummary] = useState([]);

  useEffect(() => {
    setNominatedParticipant(clickedRowData?.trainingRequisitionForm?.nameOfNominatedParticipant);
    setTrainingType(clickedRowData?.trainingRequisitionForm?.trainingType);
    setTargetSkill(clickedRowData?.trainingRequisitionForm?.targetSkills?.title);
    setOutcomeAchievedStatus(clickedRowData?.trainingRequisitionForm?.trainingDetails[0]?.OutcomeAchieved ? 'YES' : 'NO');
    setManagerFeedbackComment(clickedRowData?.trainingRequisitionForm?.trainingDetails[0]?.feedback);
    setEffectivenessSummary(clickedRowData?.trainingRequisitionForm?.trainingDetails[0]?.businessoutcomeDetails);
    setEmpTrfDetailId(clickedRowData?.trainingRequisitionForm?.trainingDetails[0]?.id);
  }, []);

  const submitFinalFeedback = () => {
    let params = {
      "id": empTrfDetailId,
      "isTMFeedback": true,
      "finalReport": finalReport,
    }
    try {
      trainingApi.updateEmployeeTraining(params).then(
        (resp) => {
          toast.success(resp.data.message);
          setTimeout(() => {
            reloadTrfHistory()
          }, 1000);
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to update");
    }
  }

  const setTrainingFinalReport = (val) => {
    setFinalReport(val)
    // formik.setFieldValue('finalReport', val);
  }

  return (
    <>
      <div>
        <div className="flex flex-wrap p-field font-bold block">
          <div className="col-4">
            <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Employee Name</label>
            <div className="p-inputgroup flex-1">
              <span className="p-inputgroup-addon">
                <i className="pi pi-user"></i>
              </span>{" "}
              <InputText id="nominatedParticipant" disabled placeholder="Employee name" className="w-full" value={nominatedParticipant} />
            </div>
          </div>
          <div className="col-4">
            <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Training Type</label>
            <div className="p-inputgroup flex-1">
              <InputText id="text" disabled placeholder="Training" className="w-full" value={trainingType} />
            </div>
          </div>
          <div className="col-4">
            <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Target Skill</label>
            <div className="p-inputgroup flex-1">
              <InputText id="text" disabled placeholder="Skills" className="w-full" value={targetSkill} />
            </div>
          </div>
        </div>

        <div className="grid">
          <div className="col-4">
            <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Outcome Achived</label>
            <div className="p-inputgroup flex-1">
              {outcomeAchievedStatus}
            </div>
          </div>
          <div className="col-4">
            <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Manager Training Feedback</label>
            <div className="p-inputgroup flex-1">
              {managerFeedbackComment}
            </div>
          </div>
        </div>

        <div className='grid'>
          <div className="col-12">
            <label htmlFor="comments" className="font-bold block mb-2 training-heading">
              Training Effectiveness Summary
            </label>
            <div className="mp-panel">
              {effectivenessSummary.map((item, index) => (
                <div className='col mr-2 bordered mt-1'>{item.title}</div>
              ))}
            </div>
          </div>
          <div className="col-12">
            <label htmlFor="comments" className="font-bold block mb-2 training-heading">
              Final Report
            </label>
            <div className="">
              <Editor name="finalReport" value={finalReport} onTextChange={(e) => setTrainingFinalReport(e.htmlValue)} style={{ height: '200px' }} />
              {/* {getFormErrorMessage('finalReport')} */}
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div className='' style={{ textAlign: 'right' }}>
        <Button label='Submit' icon='pi pi-save' severity='primary' className='mr-1' onClick={submitFinalFeedback} />
        <Button label='Cancel' type='button' icon='pi pi-times' severity='secondary' onClick={reloadTrfHistory} />
      </div>
    </>
  );
}
